import classNames from 'classnames';
import { Col } from 'antd';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import {
	SonarRecordContainer,
	SonarRecordNameSection,
	SonarRecordRow,
	SonarRecordSecondaryInfo
} from '.';

export interface SonarRecordDataProps {
	className?: string;
	isActive?: boolean;
	name: string | React.ReactElement | Array<string | React.ReactElement>;
	onClick?: () => void;
	secondaryInfo?: string;
	sonarObjectType?: SonarObjectType;
}

export const SonarRecordData: React.FC<SonarRecordDataProps> = ({
	className,
	isActive,
	name,
	onClick,
	secondaryInfo,
	sonarObjectType
}) => {
	const classes = classNames('sonar-record-data', className);

	return (
		<SonarRecordContainer
			className={ classes }
			onClick={ onClick }>
			<SonarRecordRow>
				<Col flex='none'>
					<SonarRecordNameSection
						isActive={ isActive }
						name={ name } />
				</Col>
				<SonarRecordSecondaryInfo
					info={ secondaryInfo }
					sonarObjectType={ sonarObjectType } />
			</SonarRecordRow>
		</SonarRecordContainer>
	);
};

